// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.media-preview-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: min(88dvh, 720px);
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 16px 16px;
  box-sizing: border-box;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  z-index: 10;
}
.close-btn:hover {
  background: rgba(255, 255, 255, 0.28);
}

.media-content {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.preview-image,
.preview-video {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.preview-video {
  background: #000;
  outline: none;
  width: 100%;
  max-height: 100%;
}

.media-load-error {
  color: #e5e7eb;
  text-align: center;
  padding: 16px;
  font-size: 14px;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/quick-create-flow/media-preview-dialog/media-preview-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,WAAA;AACF;AACE;EACE,qCAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAAF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n.media-preview-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: min(88dvh, 720px);\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 16px 16px;\n  box-sizing: border-box;\n}\n\n.close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  z-index: 10;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.28);\n  }\n}\n\n.media-content {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 0;\n}\n\n.preview-image,\n.preview-video {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 4px;\n}\n\n.preview-video {\n  background: #000;\n  outline: none;\n  width: 100%;\n  max-height: 100%;\n}\n\n.media-load-error {\n  color: #e5e7eb;\n  text-align: center;\n  padding: 16px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
